import {useSyncExternalStore} from "react";

const listeners = new Set();
let timer = null;
let snapshot = 0;

function emit() {
    snapshot += 1;
    listeners.forEach((listener) => listener());
}

function subscribe(listener) {
    listeners.add(listener);
    if (!timer) timer = window.setInterval(emit, 1000);
    return () => {
        listeners.delete(listener);
        if (!listeners.size && timer) {
            window.clearInterval(timer);
            timer = null;
        }
    };
}

const getSnapshot = () => snapshot;

export function useFocusClock(enabled = true) {
    const tick = useSyncExternalStore(enabled ? subscribe : () => () => {}, getSnapshot, getSnapshot);
    void tick;
    return window.performance.now();
}
